/**
 * CacheIndicator — индикатор статуса кэша прогноза
 *
 * Показывает цветную точку + текст: Fresh / Stale / Generating / Expired.
 */

import React from 'react';

type CacheStatusType = 'fresh' | 'stale' | 'generating' | 'expired';

interface CacheIndicatorProps {
  status: CacheStatusType | null;
}

const config: Record<CacheStatusType, { color: string; label: string }> = {
  fresh: { color: '#4CAF50', label: 'Fresh' },
  stale: { color: '#FFC107', label: 'Stale' },
  generating: { color: '#2196F3', label: 'Generating' },
  expired: { color: '#9E9E9E', label: 'Expired' },
};

const CacheIndicator: React.FC<CacheIndicatorProps> = ({ status }) => {
  if (status === null || status === undefined) {
    return null;
  }

  const { color, label } = config[status];

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: '11px',
        color,
        fontFamily: 'var(--font-sans)',
      }}
    >
      <span
        style={{
          display: 'inline-block',
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          background: color,
          flexShrink: 0,
        }}
      />
      {label}
    </span>
  );
};

export default CacheIndicator;
